import React, { Component } from "react";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";

import { Col, Form, Row, Tabs } from "antd";

import InDocDetail from "./includes/InDocDetail";

import InPaymentDetail from "./includes/InPaymentDetail";
import InPersonnelInformation from "./includes/InPersonnelInformation";
import InScholarshipDetail from "./includes/InScholarshipDetail";
import InTermFeeHistory from "./includes/InTermFeeHistory";
import InVacationInformation from "./includes/InVacationInformation";
import InVacationDayInformation from "./includes/InVacationDayInformation";
import InEducation from "./includes/InEducation";
import InPaymentDetail2 from "./includes/InPaymentDetail2";

const { TabPane } = Tabs;

class WelfareListStudyPaymentSecDocDetail extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
  };

  async componentDidMount() {}

  render() {
    const {
      rawData,
      form,
      dataAttachInvoiceData,
      isViewOnly,
      dataTermfeeHistory,
      onChangeDeletedAttachment,
    } = this.props;

    return (
      <Row gutter={16} className="py-2 mb-4">
        <Col md={24} className="mb-3">
          <InDocDetail forceRender rawData={rawData} />
        </Col>
        <Col md={24} className="mb-0">
          <Tabs type="card" className="mt-4">
            <TabPane tab={"ข้อมูลบุคลากร"} key="1" className="mb-0 px-0">
              <InPersonnelInformation
                forceRender
                rawData={rawData.studyLeaveRequest}
              />
            </TabPane>
            <TabPane tab={"ข้อมูลการลา"} key="2" className="mb-0 px-0">
              <InVacationInformation forceRender rawData={rawData} />
            </TabPane>
            <TabPane tab={"ข้อมูลทุน / สัญญา"} key="3" className="mb-0 px-0">
              <InScholarshipDetail
                forceRender
                rawData={rawData.studyScholarship}
              />
            </TabPane>
            <TabPane tab={"ข้อมูลวันลา"} key="4" className="mb-0 px-0">
              <InVacationDayInformation forceRender rawData={rawData} />
            </TabPane>
            <TabPane tab={"ผลการศึกษา"} key="5" className="mb-0 px-0">
              <InEducation forceRender rawData={rawData} />
            </TabPane>
            <TabPane tab={"ประวัติการเบิก"} key="6" className="mb-0 px-0">
              <InTermFeeHistory
                dataTermfeeHistory={dataTermfeeHistory}
                forceRender
              />
            </TabPane>
          </Tabs>
        </Col>
        <Col md={24} className="mb-0">
          <InPaymentDetail
            rawData={rawData}
            isViewOnly={isViewOnly}
            form={form}
            dataAttachInvoiceData={dataAttachInvoiceData}
            onChangeDeletedAttachment={onChangeDeletedAttachment}
          />
        </Col>
        {/* <Col span={24}>
          <InPaymentDetail2 rawData={rawData} />
        </Col> */}
      </Row>
    );
  }
}

WelfareListStudyPaymentSecDocDetail.defaultProps = {
  autoFocus: false,
};

WelfareListStudyPaymentSecDocDetail.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListStudyPaymentSecDocDetail = Form.create()(
  WelfareListStudyPaymentSecDocDetail
);

export default withApollo(WrappedWelfareListStudyPaymentSecDocDetail);
